// HR-owned: the wording of the About Ask HR page (/about), and when HR last reviewed it. Edit
// here; the page layout (About.tsx) holds no copy of its own.

export const ABOUT_LAST_REVIEWED = "2026-10-09"; // YYYY-MM-DD

export const ABOUT_TITLE = "About Ask HR";

export const ABOUT_INTRO =
  "Ask HR is an AI assistant that answers from Novara's approved HR documents. Answers can be incomplete or out of date. Check the linked source; if anything conflicts, the official policy document applies.";

export interface AboutSection {
  id: string;
  heading: string;
  text: string;
  testingOnly?: boolean; // shown only while Ask HR is in testing (config.ts testing)
}

export const ABOUT_SECTIONS: readonly AboutSection[] = [
  { id: "contract", heading: "Not a contract", text: "Answers don't create or change any policy, benefit, or employment terms." },
  {
    id: "records",
    heading: "Your personal records",
    text: "Ask HR can't see your pay, PTO balance, or benefit elections. Check Paylocity for those.",
  },
  {
    id: "privacy",
    heading: "Privacy",
    text: "Conversations are saved and may be reviewed by HR to improve answers. Identifying account information is removed before review.",
  },
  {
    id: "limits",
    heading: "What Ask HR can't do",
    text: "Ask HR can't approve requests or advise on performance, discipline, or termination. Contact HR for those.",
  },
  { id: "talk", heading: "Talk to HR", text: "HR may reply by email; those replies won't show up here." },
  {
    id: "testing",
    heading: "In testing",
    text: "Ask HR is in testing. Use thumbs up or thumbs down to tell us when an answer is wrong.",
    testingOnly: true,
  },
];

// The line under the question box. The link text goes to /about.
export const CHAT_DISCLAIMER = "Ask HR can make mistakes. Check the source.";
export const ABOUT_LINK_TEXT = "About Ask HR";
